import {CSSProperties, FC} from 'react';


export interface IIconEspProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconEsp: FC<IIconEspProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M8.155 16.55c.192.287.29.586.29.897 0 .982-.954 1.623-1.795 2.189-.354.238-.689.463-.922.685a.45.45 0 0 0-.014.653c.163.164.426.377.835.582.4.2.808.353 1.074.444H4.657C4.22 21.589 4 21.146 4 20.677c0-.982.953-1.623 1.794-2.189.354-.238.69-.463.922-.685l.007-.007a.45.45 0 0 0 .007-.646 3.18 3.18 0 0 0-.852-.593l-.014-.006h2.291Zm11.556 0c.192.287.289.586.289.897 0 .982-.953 1.623-1.794 2.189-.354.238-.69.463-.922.685a.45.45 0 0 0-.014.653c.163.164.426.377.835.582.4.2.808.353 1.073.444h-2.965c-.437-.411-.657-.854-.657-1.323 0-.982.953-1.623 1.793-2.189.355-.238.69-.463.923-.685l.007-.007a.45.45 0 0 0 .006-.646 3.18 3.18 0 0 0-.852-.593l-.013-.006h2.29Z" />
            <path fillRule="evenodd" d="M16.9 14.667H7.1v.666c0 .368-.313.667-.7.667h-.7c-.387 0-.7-.299-.7-.667V8.667l1.736-3.859c.22-.49.728-.808 1.288-.808h7.952c.56 0 1.066.318 1.287.808L19 8.667v6.666c0 .368-.313.667-.7.667h-.7c-.387 0-.7-.299-.7-.667v-.666ZM17.6 10H6.4v3.333h11.2V10ZM6.523 8.667h10.954l-1.5-3.334H8.024l-1.5 3.334Zm1.627 4c-.58 0-1.05-.448-1.05-1 0-.553.47-1 1.05-1 .58 0 1.05.447 1.05 1 0 .552-.47 1-1.05 1Zm7.7 0c-.58 0-1.05-.448-1.05-1 0-.553.47-1 1.05-1 .58 0 1.05.447 1.05 1 0 .552-.47 1-1.05 1Z" clipRule="evenodd" />
        </svg>
    );
};
